import { render } from "./BlankTemplate.vue?vue&type=template&id=2c107ecf"
const script = {}

import exportComponent from "/Users/teddyhuang/Documents/github/comment_helper_yt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__